<template>
  <BmSelect
    id="locale-select"
    data-testid="locale-select"
    :ariaLabel="$t('generic.selectLanguage')"
    :chevronIconAltText="$t('generic.showOptions')"
    @update:modelValue="onChange"
    :options="locales"
    :modelValue="rttI18n.locale"
    :variant="props.variant"
  />
</template>

<script setup>
import BmSelect from '@/v2/design-system/components/Select/BmSelect.vue';
import configLocales from '@/config/locales.js';
import { sendAnalytics } from '@/services/analytics.js';
import { computed, inject } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useTrackingDataStore } from '@/stores/trackingData.js';

const props = defineProps({
  variant: {
    type: String,
    required: false,
    default: 'blue',
    validator: value => ['light', 'dark', 'blue', 'outlined'].includes(value)
  }
});

const rttI18n = inject('rttI18n');
const localePlugin = inject('localePlugin');
const $t = inject('t');
const router = useRouter();
const route = useRoute();
const { data } = useTrackingDataStore();

const locales = computed(() =>
  Object.values(configLocales)
    .sort((a, b) => {
      if (a.code === rttI18n.locale) return -1;
      if (b.code === rttI18n.locale) return 1;
      return a.name.localeCompare(b.name);
    })
    .map(l => ({ value: l.code, label: l.name, attrs: { lang: l.code } }))
);

const onChange = newLocale => {
  if (newLocale !== rttI18n.locale) {
    sendAnalytics(data, 'locale', 'locale_changed', {
      oldLocale: rttI18n.locale,
      newLocale: newLocale,
      isV2: true
    });
  }
  if (route.params.countryOrTenantId) {
    router.replace({
      name: route.name,
      params: { ...route.params, locale: newLocale }
    });
  } else {
    localePlugin.updateLocale(newLocale);
  }
};
</script>
